define("settings/components/modal/form-input", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/runloop", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _runloop, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#let (uuid) as |uniqueId|}}
  
    <div class={{if @wrapperClass @wrapperClass "o--formWrapper"}}>
  
      {{#if @label}}
        <label class={{@qaClassInputLabel}} for={{uniqueId}}>
          {{@label}}
        </label>
      {{/if}}
  
      {{#if (has-block)}}
        {{yield uniqueId}}
      {{else}}
        <input
          autocomplete={{@autocomplete}}
          class="o--form__input {{if @disabled 'u--mute'}} {{@qaClass}}"
          disabled={{@disabled}}
          id={{uniqueId}}
          onchange={{action (mut @value) value="target.value"}}
          placeholder={{if @placeholder @placeholder @label}}
          required={{if @required @required true}}
          type={{if @type @type "text"}}
          value={{@value}}
          {{did-insert this.focusInput}}
        />
      {{/if}}
    </div>
  {{/let}}
  */
  {
    "id": "plm1CnGX",
    "block": "[[[44,[[28,[37,1],null,null]],[[[1,\"\\n  \"],[10,0],[15,0,[52,[30,2],[30,2],\"o--formWrapper\"]],[12],[1,\"\\n\\n\"],[41,[30,3],[[[1,\"      \"],[10,\"label\"],[15,0,[30,4]],[15,\"for\",[30,1]],[12],[1,\"\\n        \"],[1,[30,3]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[48,[30,12]],[[[1,\"      \"],[18,12,[[30,1]]],[1,\"\\n\"]],[]],[[[1,\"      \"],[11,\"input\"],[16,\"autocomplete\",[30,5]],[16,0,[29,[\"o--form__input \",[52,[30,6],\"u--mute\"],\" \",[30,7]]]],[16,\"disabled\",[30,6]],[16,1,[30,1]],[16,\"onchange\",[28,[37,5],[[30,0],[28,[37,6],[[30,8]],null]],[[\"value\"],[\"target.value\"]]]],[16,\"placeholder\",[52,[30,9],[30,9],[30,3]]],[16,\"required\",[52,[30,10],[30,10],true]],[16,2,[30,8]],[16,4,[52,[30,11],[30,11],\"text\"]],[4,[38,7],[[30,0,[\"focusInput\"]]],null],[12],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"]],[1]]]],[\"uniqueId\",\"@wrapperClass\",\"@label\",\"@qaClassInputLabel\",\"@autocomplete\",\"@disabled\",\"@qaClass\",\"@value\",\"@placeholder\",\"@required\",\"@type\",\"&default\"],false,[\"let\",\"uuid\",\"if\",\"has-block\",\"yield\",\"action\",\"mut\",\"did-insert\"]]",
    "moduleName": "settings/components/modal/form-input.hbs",
    "isStrictMode": false
  });

  let FormInputComponent = (_class = class FormInputComponent extends _component2.default {
    focusInput(element) {
      if (this.args.autofocus) {
        (0, _runloop.scheduleOnce)('afterRender', this, this._focusInput, element);
      }
    }

    _focusInput(input) {
      input.focus();
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "focusInput", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "focusInput"), _class.prototype)), _class);
  _exports.default = FormInputComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FormInputComponent);
});